exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1G-BW{width:100%;height:100%;padding:0 3px;position:absolute;top:0;left:0;display:-webkit-box;display:-ms-flexbox;display:flex;opacity:0;z-index:5;-webkit-transition:opacity .1s ease-in;-o-transition:opacity .1s ease-in;transition:opacity .1s ease-in;cursor:pointer}._1G-BW:hover{opacity:1}._2cmDv{-webkit-box-flex:1;-ms-flex:1 1 1px;flex:1 1 1px;position:relative}._2cmDv,._3rlOs{-webkit-box-sizing:border-box;box-sizing:border-box}._3rlOs{position:absolute;bottom:3px;left:0;right:0;width:98%;height:3px;background-color:#ffffffa1;margin:auto}.GK0g0 ._3rlOs{background-color:#ffd906}", ""]);

// exports
exports.locals = {
	"thumbCarousel": "_1G-BW",
	"slide": "_2cmDv",
	"slideButton": "_3rlOs",
	"currentSlide": "GK0g0"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/ThumbCarousel/ThumbCarousel.css
// module id = 1465
// module chunks = 0 1 15 17 18 19 20 21 23 24 32 33 36 37 38